import { registerPropertyManagerSection, type PropertyManagerContext } from '@/core';
import OrdinateDimensionPropertySection from '@/components/editor/property-manager/smart-dimension/OrdinateDimensionPropertySection.vue';
import type { Viewer } from '@puppycad/cad-core';

/** 尺寸链命令族（尺寸链/水平尺寸链/竖直尺寸链共用同一面板）。 */
const ORDINATE_COMMAND_IDS = new Set([
  'sketch-ordinate-dimension',
  'sketch-horizontal-ordinate-dimension',
  'sketch-vertical-ordinate-dimension',
]);

/** 读取 viewer 句柄。 */
function resolveViewer(context: PropertyManagerContext): Viewer | null {
  return (context.renderer as Viewer | null) ?? null;
}

registerPropertyManagerSection({
  id: 'sketch-ordinate-dimension',
  title: '尺寸链',
  order: 16,
  component: OrdinateDimensionPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => context.isSketchActive === true
    && typeof context.activeCommand === 'string'
    && ORDINATE_COMMAND_IDS.has(context.activeCommand),
  // ✓/✗ 与 Esc 同语义：尺寸随选随落库，确认即结束命令。
  onConfirm: (context) => {
    resolveViewer(context)?.cancelSketchSmartDimensionMode?.();
  },
  onCancel: (context) => {
    resolveViewer(context)?.cancelSketchSmartDimensionMode?.();
  },
});
